import { Drawer, IconButton, IconButtonProps, styled } from '@mui/material';

export const CustomDrawer = styled(Drawer)(({ theme, open }) => ({
  ...(open && {
    '.simplebar-content-wrapper': {
      background: `linear-gradient(178deg, ${theme.palette.background.default} 5%, ${theme.palette.primary.main}20 100%)`,

      position: 'relative',
      ':before': {
        position: 'absolute',
        content: '""',
        right: -150,
        top: 0,
        background: theme.palette.primary.main,
        height: 200,
        width: 200,
        filter: 'blur(100px)',
        borderRadius: '50%',
        opacity: 0.4,
        zIndex: -1,
        overflow: 'hidden',
      },
      ':after': {
        position: 'absolute',
        content: '""',
        left: -50,
        bottom: 100,
        background: `radial-gradient(circle, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
        height: 100,
        width: 100,
        filter: 'blur(100px)',
        borderRadius: '50%',
        opacity: 0.4,
        zIndex: -1,
        overflow: 'hidden',
      },
    },
  }),
}));

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

export const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.grey[200],
  ':hover': {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.grey[300],
  },
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));
